import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, sitConfig } from './config'

const responseParser = (response: any) => {
  return response
}

const getProgramCategoryDetails = (mccCode: string, ownerShipType: string, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: APIEndPoints.getprogrambymcc,
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: { mccCode: mccCode, entityType: ownerShipType },
  }
  return executeRequest(request)
    .then((data) => {
      return responseParser(data.data)
    })
    .catch((error) => {
      throw error
    })
}

export { getProgramCategoryDetails }
